import React from 'react';
import logo from '../images/logo.webp';
import scrollArrow from '../images/scroll-arrow.svg';
import './Start.scss';

const Start = () => {
    return <div id={'viewer'} className={'start-view'}>
        <img src={logo} alt={'Kolu.be'} className={'logo'} />
        <img src={scrollArrow} id="arrow" className="animated bounce" alt={'Scroll'} />
    </div>;
}

export default Start;